import UnderConstruction from 'components/underconstruction/UnderConstruction'
import React from 'react'

export default function Blog() {
  return (
    <div>
        Blog
    <UnderConstruction />
    </div>
  )
}

